import React from 'react';
import PropTypes from 'prop-types';

import dictonary from './dictionary';

const Icon = ({ name, width, height, style, ...props }) => {
  const { viewBox, width: dictonaryWidth, height: dictonaryHeight, id } = dictonary[name];
  const widthValue = width || dictonaryWidth;
  const heightValue = height || dictonaryHeight;

  return (
    <svg viewBox={viewBox} width={widthValue} height={heightValue} style={style} {...props}>
      <use xlinkHref={id} />
    </svg>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.shape(),
};

Icon.defaultProps = {
  width: null,
  height: null,
  style: {},
};

export default Icon;



// WEBPACK FOOTER //
// ./src/sharedComponents/Icon/Icon.js